module.exports = __webpack_public_path__ + "img/spain-cancer-male.db72c867.png";